import { ProductExample } from './ProductExample';
export const Login = {
  ProductExample,
};
